<template>
  <app-content>
    <b-container fluid>
      <b-row>
        <b-col>
          <light-tabs
            :tabs="tabs"
            :tab-binds="{
              sampleIds,
              assetModuleId,
            }"
          />
        </b-col>
      </b-row>
      <b-row
        v-if="wasOpenedFromOtherPage"
        class="px-3"
        align-h="end"
      >
        <b-button
          class="mt-3 no-internal-print"
          @click="closeTab"
          variant="primary"
        >
          {{ $t('actions.close') }}
        </b-button>
      </b-row>

    </b-container>
  </app-content>
</template>
<script>
import LightTabs from '@/components/LightTabs';
import IndividualAnalysis from '@/domain/components/installation/engineering/chromatography/methodsAndDiagnostics/individualAnalysis/index';
import ComparativeAnalysis from '@/domain/components/installation/engineering/chromatography/methodsAndDiagnostics/comparativeAnalysis/index';

export default {
  components: {
    LightTabs,
  },
  data: () => ({
    currentTabName: 'individual-analysis',
  }),
  computed: {
    currentTab() {
      return this.tabs.find(({ name }) => this.currentTabName === name);
    },
    sampleIds() {
      const sampleIdsQuery = this.$route.query.sampleIds;
      if (typeof sampleIdsQuery === 'string') {
        return [sampleIdsQuery];
      }

      return sampleIdsQuery;
    },
    assetModuleId() {
      return this.$route.params.assetModuleId;
    },
    isSingleSampleView() {
      return this.sampleIds.length === 1;
    },
    tabs() {
      return [
        {
          name: 'individual-analysis',
          title: this.$t('engineering.chromatography.methods-and-diagnostics.individual-analysis.title'),
          component: IndividualAnalysis,
        },
        ...!this.isSingleSampleView ? [{
          name: 'comparative-analysis',
          title: this.$t('engineering.chromatography.methods-and-diagnostics.comparative-analysis.title'),
          component: ComparativeAnalysis,
        }] : [],
      ];
    },
    /**
     * Verifica se a aba foi aberta a partir de outra pagina.
     *
     * Essa computed tem a intenção de testar se é possível "voltar" fechando a aba via código, pois
     * os navegadores só permitem isso caso a aba tenha sido aberta a partir de outra, e não
     * permitem quando há navegação direta por URL.
     */
    wasOpenedFromOtherPage() {
      return window.opener != null;
    },
  },
  methods: {
    closeTab() {
      this.$confirmMessage({ code: 'MC035' })
        .accepted(() => window.close());
    },
  },
};
</script>
